import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../../components/AppIcon';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    // Check if this is a Supabase invite callback
    // Supabase appends #access_token=...&type=invite to the redirect URL
    const hash = window.location?.hash;
    const params = new URLSearchParams(hash?.replace('#', '?'));
    const type = params?.get('type');

    if (type === 'invite') {
      // Extract the invitation token from the original redirect_to URL
      // The redirect_to was set to /invitation-acceptance?token=XXX
      // Supabase may pass it back or we can read it from the current URL search params
      const searchParams = new URLSearchParams(window.location?.search);
      const invitationToken = searchParams?.get('token');

      if (invitationToken) {
        navigate(`/invitation-acceptance?token=${invitationToken}`, { replace: true });
      } else {
        // No token in search params — redirect to invitation-acceptance and let it handle
        navigate('/invitation-acceptance', { replace: true });
      }
      return;
    }

    if (!loading) {
      if (user) {
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/auth/signin', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl mb-4">
          <Icon name="HardHat" size={32} color="#FFFFFF" />
        </div>
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-amber-500 border-t-transparent mb-4"></div>
        <p className="text-gray-600 text-lg">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
